export default (params) => ({
  trigger: {
    name: 'configurator.click_reviews_in_configurator',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
